import Vue from 'vue'

// add translations directly to the application
// Vue.i18n.add('BR', require('./pt_br.json'))
// Vue.i18n.add('GB', require('./en.json'))
// Vue.i18n.add('GR', require('./gr.json'))
// Vue.i18n.add('CN', require('./cn.json'))

// Vue.i18n.add('en', store.getters.appTranslations.translation)

// set the start locale to use
const appLanguage = localStorage.getItem('appLanguage')
if (appLanguage) {
  Vue.i18n.set(appLanguage)
} else {
  Vue.i18n.set('GB')
}

// set fallback for non-translated strings
Vue.i18n.fallback('GB')
